import type { Base } from "./_config/index.js"
import { Config } from "./_config/index.js"
import {
  ConnectEthereumUseCaseInput,
  ConnectEthereumUseCaseOutput,
} from "./ethereum/UseCases/ConnectEthereumUseCase.js"
import {
  WaitForTransactionEthereumUseCaseInput,
  WaitForTransactionEthereumUseCaseOutput,
} from "./ethereum/UseCases/WaitForTransactionEthereumUseCase.js"
import {
  RegisterEthereumUseCaseInput,
  RegisterEthereumUseCaseOutput,
} from "./ethereum/UseCases/RegisterEthereumUseCase.js"
import { LoginEthereumUseCaseInput, LoginEthereumUseCaseOutput } from "./ethereum/UseCases/LoginEthereumUseCase.js"
import {
  GetTransactionsEthereumUseCaseInput,
  GetTransactionsEthereumUseCaseOutput,
} from "./ethereum/UseCases/GetTransactionsEthereumUseCase.js"
import {
  CleanTransactionsEthereumUseCaseInput,
  CleanTransactionsEthereumUseCaseOutput,
} from "./ethereum/UseCases/CleanTransactionsEthereumUseCase.js"
import {
  DisconnectEthereumUseCaseInput,
  DisconnectEthereumUseCaseOutput,
} from "./ethereum/UseCases/DisconnectEthereumUseCase.js"
import {
  GetWalletStateEthereumUseCaseInput,
  GetWalletStateEthereumUseCaseOutput,
} from "./ethereum/UseCases/GetWalletStateEthereumUseCase.js"
import {
  SwitchChainEthereumUseCaseInput,
  SwitchChainEthereumUseCaseOutput,
} from "./ethereum/UseCases/SwitchChainEthereumUseCase.js"
import {
  ReconnectEthereumUseCaseInput,
  ReconnectEthereumUseCaseOutput,
} from "./ethereum/UseCases/ReconnectEthereumUseCase.js"
import {
  InitPublicClientEthereumUseCaseInput,
  InitPublicClientEthereumUseCaseOutput,
} from "./ethereum/UseCases/InitPublicClientEthereumUseCase.js"
import { SendAuthCodeAuthUseCaseInput, SendAuthCodeAuthUseCaseOutput } from "./auth/UseCases/SendAuthCodeAuthUseCase.js"
import { SignUpAuthUseCaseInput, SignUpAuthUseCaseOutput } from "./auth/UseCases/SignUpAuthUseCase.js"
import { SignInAuthUseCaseInput, SignInAuthUseCaseOutput } from "./auth/UseCases/SignInAuthUseCase.js"
import {
  GetAuthPayloadAuthUseCaseInput,
  GetAuthPayloadAuthUseCaseOutput,
} from "./auth/UseCases/GetAuthPayloadAuthUseCase.js"
import { LogoutAuthUseCaseInput, LogoutAuthUseCaseOutput } from "./auth/UseCases/LogoutAuthUseCase.js"
import {
  GetVotingByIdVoteUseCaseInput,
  GetVotingByIdVoteUseCaseOutput,
} from "./vote/UseCases/GetVotingByIdVoteUseCase.js"
import { GetVoteListVoteUseCaseInput, GetVoteListVoteUseCaseOutput } from "./vote/UseCases/GetVoteListVoteUseCase.js"
import {
  GetUserVoteListAggregateUseCaseInput,
  GetUserVoteListAggregateUseCaseOutput,
} from "./vote/UseCases/GetUserVoteListAggregateUseCase.js"
import { UpdateUserVoteUseCaseInput, UpdateUserVoteUseCaseOutput } from "./vote/UseCases/UpdateUserVoteUseCase.js"
import {
  CreateKYCSessionUserUseCaseInput,
  CreateKYCSessionUserUseCaseOutput,
} from "./user/UseCases/CreateKYCSessionUserUseCase.js"
import {
  GetStatusKYCSessionUserUseCaseInput,
  GetStatusKYCSessionUserUseCaseOutput,
} from "./user/UseCases/GetStatusKYCSessionUserUseCase.js"
import { GetUserInfoUserUseCaseInput, GetUserInfoUserUseCaseOutput } from "./user/UseCases/GetUserInfoUserUseCase.js"
import { CreateWalletUserUseCaseInput, CreateWalletUserUseCaseOutput } from "./user/UseCases/CreateWalletUserUseCase.js"
import {
  SetParticipationRolesUserUseCaseInput,
  SetParticipationRolesUserUseCaseOutput,
} from "./user/UseCases/SetParticipationRolesUserUseCase.js"
import {
  GetSubscriptionPlansUseCaseInput,
  GetSubscriptionPlansUseCaseOutput,
} from "./subscription/UseCases/GetSubscriptionPlansUseCase.js"
import {
  GetMySubscriptionUseCaseInput,
  GetMySubscriptionUseCaseOutput,
} from "./subscription/UseCases/GetMySubscriptionUseCase.js"
import {
  CreateSubscriptionUseCaseInput,
  CreateSubscriptionUseCaseOutput,
} from "./subscription/UseCases/CreateSubscriptionUseCase.js"
import {
  CancelMySubscriptionUseCaseInput,
  CancelMySubscriptionUseCaseOutput,
} from "./subscription/UseCases/CancelMySubscriptionUseCase.js"
import {
  GetNotificationsNotificationUseCaseInput,
  GetNotificationsNotificationUseCaseOutput,
} from "./notification/UseCases/GetNotificationsNotificationUseCase.js"
import {
  GetUnreadCountNotificationUseCaseInput,
  GetUnreadCountNotificationUseCaseOutput,
} from "./notification/UseCases/GetUnreadCountNotificationUseCase.js"
import {
  MarkNotificationReadNotificationUseCaseInput,
  MarkNotificationReadNotificationUseCaseOutput,
} from "./notification/UseCases/MarkNotificationReadNotificationUseCase.js"
import {
  MarkAllNotificationsReadNotificationUseCaseInput,
  MarkAllNotificationsReadNotificationUseCaseOutput,
} from "./notification/UseCases/MarkAllNotificationsReadNotificationUseCase.js"
import {
  GetNotificationPreferencesNotificationUseCaseInput,
  GetNotificationPreferencesNotificationUseCaseOutput,
} from "./notification/UseCases/GetNotificationPreferencesNotificationUseCase.js"
import {
  UpdateNotificationPreferencesNotificationUseCaseInput,
  UpdateNotificationPreferencesNotificationUseCaseOutput,
} from "./notification/UseCases/UpdateNotificationPreferencesNotificationUseCase.js"

export class Domain {
  #config: Config

  static create(config: Base) {
    return new Domain(config)
  }

  constructor(config: Base) {
    this.#config = Config.create(config)
  }

  get config() {
    return this.#config
  }

  /** Ethereum */
  get InitPublicClientEthereumUseCase () { return this.#getter<InitPublicClientEthereumUseCaseInput, InitPublicClientEthereumUseCaseOutput>(async () => import("./ethereum/UseCases/InitPublicClientEthereumUseCase.js"), "InitPublicClientEthereumUseCase") } // prettier-ignore
  get ConnectEthereumUseCase() { return this.#getter<ConnectEthereumUseCaseInput, ConnectEthereumUseCaseOutput>(async () => import("./ethereum/UseCases/ConnectEthereumUseCase.js"), "ConnectEthereumUseCase") } // prettier-ignore
  get DisconnectEthereumUseCase() { return this.#getter<DisconnectEthereumUseCaseInput, DisconnectEthereumUseCaseOutput>(async () => import("./ethereum/UseCases/DisconnectEthereumUseCase.js"), "DisconnectEthereumUseCase") } // prettier-ignore
  get GetWalletStateEthereumUseCase() { return this.#getter<GetWalletStateEthereumUseCaseInput, GetWalletStateEthereumUseCaseOutput>(async () => import("./ethereum/UseCases/GetWalletStateEthereumUseCase.js"), "GetWalletStateEthereumUseCase") } // prettier-ignore
  get SwitchChainEthereumUseCase() { return this.#getter<SwitchChainEthereumUseCaseInput, SwitchChainEthereumUseCaseOutput>(async () => import("./ethereum/UseCases/SwitchChainEthereumUseCase.js"), "SwitchChainEthereumUseCase") } // prettier-ignore
  get ReconnectEthereumUseCase() { return this.#getter<ReconnectEthereumUseCaseInput, ReconnectEthereumUseCaseOutput>(async () => import("./ethereum/UseCases/ReconnectEthereumUseCase.js"), "ReconnectEthereumUseCase") } // prettier-ignore
  get GetTransactionsEthereumUseCase() { return this.#getter<GetTransactionsEthereumUseCaseInput, GetTransactionsEthereumUseCaseOutput>(async () => import("./ethereum/UseCases/GetTransactionsEthereumUseCase.js"), "GetTransactionsEthereumUseCase") } // prettier-ignore
  get WaitForTransactionEthereumUseCase() { return this.#getter<WaitForTransactionEthereumUseCaseInput, WaitForTransactionEthereumUseCaseOutput>(async () => import("./ethereum/UseCases/WaitForTransactionEthereumUseCase.js"), "WaitForTransactionEthereumUseCase") } // prettier-ignore
  get RegisterEthereumUseCase() { return this.#getter<RegisterEthereumUseCaseInput, RegisterEthereumUseCaseOutput>(async () => import("./ethereum/UseCases/RegisterEthereumUseCase.js"), "RegisterEthereumUseCase") } // prettier-ignore
  get LoginEthereumUseCase() { return this.#getter<LoginEthereumUseCaseInput, LoginEthereumUseCaseOutput>(async () => import("./ethereum/UseCases/LoginEthereumUseCase.js"), "LoginEthereumUseCase") } // prettier-ignore
  get CleanTransactionsEthereumUseCase() { return this.#getter<CleanTransactionsEthereumUseCaseInput, CleanTransactionsEthereumUseCaseOutput>(async () => import("./ethereum/UseCases/CleanTransactionsEthereumUseCase.js"), "CleanTransactionsEthereumUseCase") } // prettier-ignore

  /** Auth */
  get SendAuthCodeAuthUseCase() { return this.#getter<SendAuthCodeAuthUseCaseInput, SendAuthCodeAuthUseCaseOutput>(async () => import("./auth/UseCases/SendAuthCodeAuthUseCase.js"), "SendAuthCodeAuthUseCase") } // prettier-ignore
  get SignUpAuthUseCase() { return this.#getter<SignUpAuthUseCaseInput, SignUpAuthUseCaseOutput>(async () => import("./auth/UseCases/SignUpAuthUseCase.js"), "SignUpAuthUseCase") } // prettier-ignore
  get SignInAuthUseCase() { return this.#getter<SignInAuthUseCaseInput, SignInAuthUseCaseOutput>(async () => import("./auth/UseCases/SignInAuthUseCase.js"), "SignInAuthUseCase") } // prettier-ignore
  get GetAuthPayloadAuthUseCase() { return this.#getter<GetAuthPayloadAuthUseCaseInput, GetAuthPayloadAuthUseCaseOutput>(async () => import("./auth/UseCases/GetAuthPayloadAuthUseCase.js"), "GetAuthPayloadAuthUseCase") } // prettier-ignore
  get LogoutAuthUseCase() { return this.#getter<LogoutAuthUseCaseInput, LogoutAuthUseCaseOutput>(async () => import("./auth/UseCases/LogoutAuthUseCase.js"), "LogoutAuthUseCase") } // prettier-ignore

  /** Vote */
  get GetVotingByIdVoteUseCase() { return this.#getter<GetVotingByIdVoteUseCaseInput, GetVotingByIdVoteUseCaseOutput>(async () => import("./vote/UseCases/GetVotingByIdVoteUseCase.js"), "GetVotingByIdVoteUseCase") } // prettier-ignore
  get GetVoteListVoteUseCase() { return this.#getter<GetVoteListVoteUseCaseInput, GetVoteListVoteUseCaseOutput>(async () => import("./vote/UseCases/GetVoteListVoteUseCase.js"), "GetVoteListVoteUseCase") } // prettier-ignore
  get GetUserVoteListAggregateUseCase() { return this.#getter<GetUserVoteListAggregateUseCaseInput, GetUserVoteListAggregateUseCaseOutput>(async () => import("./vote/UseCases/GetUserVoteListAggregateUseCase.js"), "GetUserVoteListAggregateUseCase") } // prettier-ignore
  get UpdateUserVoteUseCase() { return this.#getter<UpdateUserVoteUseCaseInput, UpdateUserVoteUseCaseOutput>(async () => import("./vote/UseCases/UpdateUserVoteUseCase.js"), "UpdateUserVoteUseCase") } // prettier-ignore

  /** User */
  get CreateKYCSessionUserUseCase() { return this.#getter<CreateKYCSessionUserUseCaseInput, CreateKYCSessionUserUseCaseOutput>(async () => import("./user/UseCases/CreateKYCSessionUserUseCase.js"), "CreateKYCSessionUserUseCase") } // prettier-ignore
  get GetStatusKYCSessionUserUseCase() { return this.#getter<GetStatusKYCSessionUserUseCaseInput, GetStatusKYCSessionUserUseCaseOutput>(async () => import("./user/UseCases/GetStatusKYCSessionUserUseCase.js"), "GetStatusKYCSessionUserUseCase") } // prettier-ignore
  get GetUserInfoUserUseCase() { return this.#getter<GetUserInfoUserUseCaseInput, GetUserInfoUserUseCaseOutput>(async () => import("./user/UseCases/GetUserInfoUserUseCase.js"), "GetUserInfoUserUseCase") } // prettier-ignore
  get CreateWalletUserUseCase() { return this.#getter<CreateWalletUserUseCaseInput, CreateWalletUserUseCaseOutput>(async () => import("./user/UseCases/CreateWalletUserUseCase.js"), "CreateWalletUserUseCase") } // prettier-ignore
  get SetParticipationRolesUserUseCase() { return this.#getter<SetParticipationRolesUserUseCaseInput, SetParticipationRolesUserUseCaseOutput>(async () => import("./user/UseCases/SetParticipationRolesUserUseCase.js"), "SetParticipationRolesUserUseCase") } // prettier-ignore

  /** Subscription */
  get GetSubscriptionPlansUseCase() { return this.#getter<GetSubscriptionPlansUseCaseInput, GetSubscriptionPlansUseCaseOutput>(async () => import("./subscription/UseCases/GetSubscriptionPlansUseCase.js"), "GetSubscriptionPlansUseCase") } // prettier-ignore
  get GetMySubscriptionUseCase() { return this.#getter<GetMySubscriptionUseCaseInput, GetMySubscriptionUseCaseOutput>(async () => import("./subscription/UseCases/GetMySubscriptionUseCase.js"), "GetMySubscriptionUseCase") } // prettier-ignore
  get CreateSubscriptionUseCase() { return this.#getter<CreateSubscriptionUseCaseInput, CreateSubscriptionUseCaseOutput>(async () => import("./subscription/UseCases/CreateSubscriptionUseCase.js"), "CreateSubscriptionUseCase") } // prettier-ignore
  get CancelMySubscriptionUseCase() { return this.#getter<CancelMySubscriptionUseCaseInput, CancelMySubscriptionUseCaseOutput>(async () => import("./subscription/UseCases/CancelMySubscriptionUseCase.js"), "CancelMySubscriptionUseCase") } // prettier-ignore

  /** Notification */
  get GetNotificationsNotificationUseCase() { return this.#getter<GetNotificationsNotificationUseCaseInput, GetNotificationsNotificationUseCaseOutput>(async () => import("./notification/UseCases/GetNotificationsNotificationUseCase.js"), "GetNotificationsNotificationUseCase") } // prettier-ignore
  get GetUnreadCountNotificationUseCase() { return this.#getter<GetUnreadCountNotificationUseCaseInput, GetUnreadCountNotificationUseCaseOutput>(async () => import("./notification/UseCases/GetUnreadCountNotificationUseCase.js"), "GetUnreadCountNotificationUseCase") } // prettier-ignore
  get MarkNotificationReadNotificationUseCase() { return this.#getter<MarkNotificationReadNotificationUseCaseInput, MarkNotificationReadNotificationUseCaseOutput>(async () => import("./notification/UseCases/MarkNotificationReadNotificationUseCase.js"), "MarkNotificationReadNotificationUseCase") } // prettier-ignore
  get MarkAllNotificationsReadNotificationUseCase() { return this.#getter<MarkAllNotificationsReadNotificationUseCaseInput, MarkAllNotificationsReadNotificationUseCaseOutput>(async () => import("./notification/UseCases/MarkAllNotificationsReadNotificationUseCase.js"), "MarkAllNotificationsReadNotificationUseCase") } // prettier-ignore
  get GetNotificationPreferencesNotificationUseCase() { return this.#getter<GetNotificationPreferencesNotificationUseCaseInput, GetNotificationPreferencesNotificationUseCaseOutput>(async () => import("./notification/UseCases/GetNotificationPreferencesNotificationUseCase.js"), "GetNotificationPreferencesNotificationUseCase") } // prettier-ignore
  get UpdateNotificationPreferencesNotificationUseCase() { return this.#getter<UpdateNotificationPreferencesNotificationUseCaseInput, UpdateNotificationPreferencesNotificationUseCaseOutput>(async () => import("./notification/UseCases/UpdateNotificationPreferencesNotificationUseCase.js"), "UpdateNotificationPreferencesNotificationUseCase") } // prettier-ignore

  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  #getter<I, O>(loader: Function, name: string) {
    return {
      execute: async (input: I): Promise<O> => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        const Klass = await loader().then((mod) => mod[name])
        const uc = Klass.create({ config: this.#config })

        return uc.execute(input) as O
      },
    }
  }
}
